import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { saveListBO } from './list.model';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  SaveorUpdateList(saveList: saveListBO): Observable<any> {
    let url = "api/List/SaveList";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  DeleteList(ListId: any): Observable<any> {
    let url = "api/List/DeleteList/" + ListId;
    return this.http.delete(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
